import { Tabs as MuiTabs, TabsProps as MuiTabsProps } from '@mui/material';

export const Tabs = MuiTabs;
export type TabsProps = MuiTabsProps;
